export const GOOGLE_GROUPS_MAILTO = "mailto:dark-nw-subscribers+subscribe@googlegroups.com?subject=Dark Northwest newsletter&body=Automatically subscribe me";
